// extracted by mini-css-extract-plugin
export var calendarView = "_kb-0";